import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'


// images
import hero from "./Images/hero.svg";
import memberbenefitsimage from "./Images/galleryimage4.svg";



// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import LeadersTeam from './TeamMember/LeadersTeam';
import CordinatorTeam from './TeamMember/CordinatorTeam';
import Members from './TeamMember/Members';
import axios from 'axios';


interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
}


interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}



const Member = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[pagedata, setPagedata] = useState<datastructure[]>([]);
  const[bannerdata, setBannerdata] = useState<banner[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          `${api}/auth/memberpage`,{
            
      });

        //console.log('memberpage data',response.data)
        setPagedata(response.data);
        //console.log("memberpage data in a array",pagedata);
      } catch (error) {
        console.error("memberpage Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          `${api}/auth/memberbanner`,{
            
      });

        //console.log('member banner data',response.data)
        setBannerdata(response.data);
        //console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("member banner Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
        <Header/>
        {bannerdata.filter((item)=>item.pageName === 'MemberPage').map((items)=>(
           <div
           className="w-full h-[451px] relative hidden"
           style={{
            backgroundImage: `url(${api}/${items.image.replace(/\\/g, '/')})`,
             backgroundPosition: "center",
             backgroundSize: "cover",
           }}
         >
           {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
           <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
             <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
             {items.title}
             </h2>
             <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
             {items.content}
             </p>
             <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
               <a
                 className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
                 href="/"
               >
                 {" "}
                 <FaHome />
                 Home
               </a>
               <a
                 className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
                 href="/members"
               >
                 {" "}
                 <IoIosArrowForward />
                 Members            </a>
             
             </div>
           </div>
         </div>
        ))}
       
      <div className="bg-[#1E2A3A] py-14 px-[8%] border-b border-[#465468] ">
        <div className="flex flex-wrap gap-y-[20px] w-[100%]">
          <div className="lg:w-[55%] w-[100%] pr-[40px]">

            {pagedata.filter((items)=>items.title === 'paragraph').map((items)=>(
 <p className="lg:text-justify text-start text-[#CBD5E0] text-[20px] mb-10">
{items.content}
 </p>
            ))}
           
            <span className="text-[#FDBC12] text-[16px] hidden">KNOW MORE</span>
            {pagedata.filter((items)=>items.title === 'list').map((items,index)=>(
 <p className="lg:text-justify text-start text-[#94A2B8] text-[20px] my-5">
{index+1} {items.content}
 </p>
            ))}
          </div>
          <div className="lg:w-[45%] w-[100%] flex lg:justify-end justify-center">
            <img className="w-[75%]" src={memberbenefitsimage} alt="" />
          </div>
        </div>
      </div>
      
     <Members/>
        <Footer/>
    </div>
  )
}

export default Member